import { getCurrencyFromRegion } from "@Components/LeadFormModal/utils";
import { AppState } from "@Store/index";
import getCashBackValue from "@Utils/getCashBackValue";
import currencyData from "constants/currencyConstants";
import { PAGE } from "constants/index";
import getCurrencySymbol from "helpers/getCurrencySymbol";
import { shallowEqual, useSelector } from "react-redux";

const useCashBackValue = ({ page }: { page: string }) => {
  const { combinedNameSearchPage, currencyPropertyPage, currencyExchangeRates } = useSelector(
    ({ searchPageData, propertyPageData, appData }: AppState) => ({
      combinedNameSearchPage: searchPageData?.region?.combined_name,
      currencyPropertyPage: propertyPageData?.data?.pricing?.currency,
      currencyExchangeRates: appData?.currencyExchangeRates,
    }),
    shallowEqual,
  );

  const currency = () => {
    if (page === PAGE.HOME) return "pound";
    if (page === PAGE.SEARCH) return getCurrencyFromRegion(combinedNameSearchPage) || "pound";
    if (page === PAGE.INVENTORY) return currencyPropertyPage || "pound";
    return "pound";
  };

  const cashbackObject = getCashBackValue(currency());
  if (currencyExchangeRates?.baseCurrency) {
    const currentCurrencyObject = currencyData?.find(
      (c) => c.symbol === cashbackObject.cashbackCurrency,
    );
    const exchangeRate = currencyExchangeRates?.rates?.find(
      (rate) =>
        rate.target_currency?.toLowerCase() === currentCurrencyObject?.standard_name?.toLowerCase(),
    );
    if (exchangeRate?.rate) {
      cashbackObject.cashbackValue = Math.ceil(
        Number(cashbackObject.cashbackValue) / exchangeRate.rate,
      );
      cashbackObject.cashbackCurrency = getCurrencySymbol(currencyExchangeRates?.baseCurrency);
    }
  }

  const displayValue = `${cashbackObject.cashbackCurrency}${cashbackObject.cashbackValue}`;

  return { displayValue, video: cashbackObject.video };
};

export default useCashBackValue;
